// Interruptores de relanzamiento (2026-10-27). Cada uno apaga UNA función sin borrar
// su código: para volver a encenderla basta cambiar la constante a true.
//
// EMERGENCIAS_ACTIVAS: grúa/jompeo/cerrajero/goma y el modo proveedor (GPS).
//   Apagado: sin accesos visibles y /emergency-request y /provider/mode redirigen.
// VOZ_EN_VIVO_ACTIVA: botón de llamada de voz en tiempo real (Gemini Live) del asistente.
//   El dictado normal (transcribe) no depende de este flag. Encendida en el relanzamiento;
//   el interruptor de emergencia SIN redeploy es `config/aiLive.enabled === false` (servidor).
// REGISTRO_MECANICO_ACTIVO: opción «Mecánico» en el selector de rol del registro.
//   Los mecánicos existentes no se ven afectados.
// BORRADO_CUENTA_DIRECTO: borrado inmediato vía callable deleteAccount (se niega con la
//   migración encendida). Apagado: el usuario envía una solicitud al equipo de soporte.
export const EMERGENCIAS_ACTIVAS = false;
export const VOZ_EN_VIVO_ACTIVA = true;
export const REGISTRO_MECANICO_ACTIVO = false;
export const BORRADO_CUENTA_DIRECTO = false;
